import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "React Bricks - visual blocks editor for NextJS #CodeWithSwiz 22",
  "description": "Tried a new visual editor for NextJS and CreateReactApp. Got a site up in 20min 🤘",
  "published": "2021-02-09T00:00:00.000Z",
  "hero": "./img/hero-page.png",
  "categories": "CodeWithSwiz, Technical, NextJS, Vercel, Livecoding"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Tried a new visual editor for NextJS and CreateReactApp. Got a site up in 20min 🤘`}</p>
    <p><em parentName="p">{`CodeWithSwiz is a weekly live show. Like a podcast with video and fun hacking. Focused on experiments and open source. `}<a parentName="em" {...{
          "href": "https://youtube.com/swizecteller"
        }}>{`Join live Mondays`}</a></em></p>
    <lite-youtube {...{
      "videoid": "AA7kzViQwWY",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`A friend asked me to try `}<a parentName="p" {...{
        "href": "https://reactbricks.com/"
      }}>{`React Bricks`}</a>{` and honestly I was skeptical. Visual website builders. Pfft. What self-respecting web developer uses a WYSIWYG?`}</p>
    <p>{`Give me markdown or give me death.`}</p>
    <p>{`And then we got this page up in 20 minutes. It's pretty, easy to edit, and anyone can use it to run experiments. No custom code.`}</p>
    <p><a parentName="p" {...{
        "href": "https://cms-experiment.vercel.app/"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.569506726457405%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'206\\'%20viewBox=\\'0%200%20400%20206\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M129%2050l3%209c3%2010%206%2011%209%203l2-4%201%204c3%207%205%207%208-2%204-9%204-10%201-10l-2%202-2%206-1%203-2-5c-2-7-5-7-7-1s-2%206-4-1c-1-3-1-4-4-4h-2m28%207c-2%202-3%206%200%208%202%202%209%203%209%201%200-1-1-2-3-2l-3-1%204-1c3%200%204-1%201-5-1-3-5-3-8%200m32%200c-3%201-3%206%200%208%202%203%207%202%209%200%204-4%201-10-4-10l-5%202m13%204c0%205%200%206%202%206s2-1%202-3c0-4%202-7%203-5l1%204c0%203%200%204%202%204s2-1%202-4c1-6%202-5%203%200%200%203%201%204%202%204%202%200%202-1%202-5%200-6%200-6-3-7l-3%201h-2l-6-1h-5v6m24-5c-3%201-3%206-2%209%202%202%2010%203%2010%201%200-1-1-2-3-2l-3-1%204-1c3%200%204-1%201-5-1-2-4-3-7-1m29%201c-4%204-1%2010%205%2010%203%200%206-3%206-6s-3-6-6-6l-5%202M112%2078l-1%202-2%202%201%201v3c-2%202-1%207%200%208l2-2c0-3%202-3%202%200l1%202%202-2%202-2v-6c2-3%202-8%200-8l-3%202v3l-1-3c0-3-3-3-3%200m13%200c-6%207%201%2019%2010%2015%202-1%202-4-1-3-5%200-6-1-6-5s1-5%204-5c7%200%206-4-1-4l-6%202m37%201c0%203%200%203-2%202-3%200-7%203-7%207%200%203%204%206%206%206l5-1c2%200%202%200%202-8s0-9-2-9-2%201-2%203m19-2l3%208c3%209%206%2011%208%204%202-5%203-6%204-1%202%208%205%207%208-3%204-9%204-9%201-9-1%200-2%201-4%206l-2%205-1-5c-3-8-5-8-7-1-2%206-2%206-4%200-1-3-2-5-4-5l-2%201m45%208c0%207%200%208%202%208s2-1%202-4c0-6%203-5%204%200%200%203%201%204%202%204%202%200%202-1%202-4%200-6-2-8-6-8-2%201-2%201-2-2%200-2%200-3-2-3s-2%201-2%209m17-8c-2%201-3%204-2%206%200%202%202%203%207%204%204%201%201%203-3%203-6-1-6%202-1%203s8%200%209-3c2-3%200-6-4-7l-4-1c-1-2%202-3%205-2%202%201%204-1%203-3h-10m-102%206c-2%201-3%207-1%209%207%205%2016-3%2010-9-2-2-6-3-9%200m30%200c-5%204-1%2012%206%2011%203-1%203-4-1-4l-3-1%204-1c4%200%204-2%201-5-2-2-5-3-7%200m84%200l2%205c3%206%205%207%207%202l1-2%201%202c2%205%205%203%208-3%202-5%202-5%200-5l-3%203-2%203-1-3c-2-4-4-4-5%200l-2%203-1-3-3-3-2%201m-86%2073c-5%203-6%209-3%2014%202%205%203%205%2035%205h31l3-3c3-2%203-4%203-7s0-5-3-7l-3-3h-30l-33%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/95261d1626b71a9bbcd41e4d49e60c62/ca0a1/USh3X7pnghj01jg.webp 223w", "/static/95261d1626b71a9bbcd41e4d49e60c62/75680/USh3X7pnghj01jg.webp 445w", "/static/95261d1626b71a9bbcd41e4d49e60c62/8d1ba/USh3X7pnghj01jg.webp 890w", "/static/95261d1626b71a9bbcd41e4d49e60c62/3838e/USh3X7pnghj01jg.webp 1335w", "/static/95261d1626b71a9bbcd41e4d49e60c62/65131/USh3X7pnghj01jg.webp 1586w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/95261d1626b71a9bbcd41e4d49e60c62/e92b6/USh3X7pnghj01jg.png 223w", "/static/95261d1626b71a9bbcd41e4d49e60c62/e66bf/USh3X7pnghj01jg.png 445w", "/static/95261d1626b71a9bbcd41e4d49e60c62/4ef49/USh3X7pnghj01jg.png 890w", "/static/95261d1626b71a9bbcd41e4d49e60c62/4e814/USh3X7pnghj01jg.png 1335w", "/static/95261d1626b71a9bbcd41e4d49e60c62/c655d/USh3X7pnghj01jg.png 1586w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/95261d1626b71a9bbcd41e4d49e60c62/4ef49/USh3X7pnghj01jg.png",
              "alt": "USh3X7pnghj01jg",
              "title": "USh3X7pnghj01jg",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`We even got the founder to leave a totally real review.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e154525c4cdcab90af5db9fe0c8460ef/187fa/Definitely-real-reviewdh02e4.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "25.56053811659193%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'102\\'%20viewBox=\\'0%200%20400%20102\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M121%2056c-7%205%202%2025%2011%2023%202%200%202-1%201-4l1-4%201-6%201-5-1-3c-4-3-11-4-14-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e154525c4cdcab90af5db9fe0c8460ef/ca0a1/Definitely-real-reviewdh02e4.webp 223w", "/static/e154525c4cdcab90af5db9fe0c8460ef/75680/Definitely-real-reviewdh02e4.webp 445w", "/static/e154525c4cdcab90af5db9fe0c8460ef/8d1ba/Definitely-real-reviewdh02e4.webp 890w", "/static/e154525c4cdcab90af5db9fe0c8460ef/de1dc/Definitely-real-reviewdh02e4.webp 1194w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e154525c4cdcab90af5db9fe0c8460ef/e92b6/Definitely-real-reviewdh02e4.png 223w", "/static/e154525c4cdcab90af5db9fe0c8460ef/e66bf/Definitely-real-reviewdh02e4.png 445w", "/static/e154525c4cdcab90af5db9fe0c8460ef/4ef49/Definitely-real-reviewdh02e4.png 890w", "/static/e154525c4cdcab90af5db9fe0c8460ef/187fa/Definitely-real-reviewdh02e4.png 1194w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e154525c4cdcab90af5db9fe0c8460ef/4ef49/Definitely-real-reviewdh02e4.png",
                "alt": "Definitely real review",
                "title": "Definitely real review",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Definitely real review`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "how-it-works"
    }}>{`How it works`}</h2>
    <p><a parentName="p" {...{
        "href": "https://reactbricks.com/"
      }}>{`React Bricks`}</a>{` is currently in beta and worth a try. Going to be a paid tool when it's ready.`}</p>
    <p>{`Start with a CLI command to create a new site and follow the prompts:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ npx create-reactbricks-app
`}</code></pre>
    <p>{`You get a NextJS project (or CRA) configured to use with React Bricks. Beautiful default setup using Tailwind and a couple bricks to show what's possible.`}</p>
    <p>{`There's the usual suspects like hero headers, testimonials, email signup, image with left-text, FAQ, etc. Everything you need for a generic yet decent landing page.`}</p>
    <p>{`Copy is what matters 😉`}</p>
    <p>{`Click the edit button, login with your React Bricks account, and you get a visual editor.`}</p>
    <p><img parentName="p" {...{
        "src": "/2a2ba56068e15fc5f5e0032e9e6b9f63/Visually-editing-a-Brickjb8i1a.gif",
        "alt": "Visually editing a Brick"
      }}></img></p>
    <p>{`Typical visual editors suck. They're fiddly. Click the wrong thing and lose all your work kind of fiddly.`}</p>
    <p>{`But this one was nice. Felt stable. I couldn't get it to lose my work.`}</p>
    <p>{`Except that one time I didn't notice a required field and couldn't save and refreshed the page. But that's on me.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media4.giphy.com/media/3ohzdYJK1wAdPWVk88/giphy-loop.mp4?cid=7cf28b0fctj6blo17n0u2j9mabnhkum43v4mh8xoq2mx647n&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <h3 {...{
      "id": "deploy"
    }}>{`Deploy`}</h3>
    <p>{`When you're happy with the page, Vercel is your friend.`}</p>
    <pre><code parentName="pre" {...{}}>{`$ vercel
`}</code></pre>
    <p>{`Page goes live and becomes a typical NextJS site. Render-on-demand, cached for speed, HTML has all the content.`}</p>
    <p>{`Editor works on your live page. No need for local dev environments 🤘`}</p>
    <p>{`You have to re-deploy for changes to go live.`}</p>
    <h3 {...{
      "id": "go-live-button"
    }}>{`Go live button`}</h3>
    <p>{`A deploy webhook gives you the Go Live button. Anyone can press this without engineering skills and that's love.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/a10e54c2d58c00ce92c0acf85c93cb55/6569d/React-Bricks-deploy-screen0g8dc9.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "82.0627802690583%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'328\\'%20viewBox=\\'0%200%20400%20328\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M122%20162c0%203%200%203-1%201-1-3-7-4-8-2h-1l-2-1-2%201h-1c-2-2-5-1-5%202s3%204%204%202v-1c-2%201-2%200-2-1%200-3%200-3%203%201%202%202%203%202%204%201h3c1%201%201%201%201-2%200-1%200-2%201-1%201%204%201%204%202%202%201-3%201-3%201-1%200%203%203%205%204%202l1-4%202%202c1%203%202%203%203-1v-1c-2%202-2%202-3-1-2-3-3-3-4%202M14%20253v11l1%209h74v-21l-37-1H15l-1%202m1%2041c-2%201-1%2019%200%2020l34%201h32v-22H48l-33%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a10e54c2d58c00ce92c0acf85c93cb55/ca0a1/React-Bricks-deploy-screen0g8dc9.webp 223w", "/static/a10e54c2d58c00ce92c0acf85c93cb55/75680/React-Bricks-deploy-screen0g8dc9.webp 445w", "/static/a10e54c2d58c00ce92c0acf85c93cb55/8d1ba/React-Bricks-deploy-screen0g8dc9.webp 890w", "/static/a10e54c2d58c00ce92c0acf85c93cb55/9821d/React-Bricks-deploy-screen0g8dc9.webp 1328w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a10e54c2d58c00ce92c0acf85c93cb55/e92b6/React-Bricks-deploy-screen0g8dc9.png 223w", "/static/a10e54c2d58c00ce92c0acf85c93cb55/e66bf/React-Bricks-deploy-screen0g8dc9.png 445w", "/static/a10e54c2d58c00ce92c0acf85c93cb55/4ef49/React-Bricks-deploy-screen0g8dc9.png 890w", "/static/a10e54c2d58c00ce92c0acf85c93cb55/6569d/React-Bricks-deploy-screen0g8dc9.png 1328w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a10e54c2d58c00ce92c0acf85c93cb55/4ef49/React-Bricks-deploy-screen0g8dc9.png",
                "alt": "React Bricks deploy screen",
                "title": "React Bricks deploy screen",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`React Bricks deploy screen`}</figcaption>{`
  `}</figure></p>
    <p>{`We set `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=AA7kzViQwWY&t=1820s"
      }}>{`this up on stream`}</a>{`.`}</p>
    <p>{`Go into Vercel dashboard, integrate with Git. You don't have git-based version control because of the visual editor, but okay Vercel likes it that way.`}</p>
    <p>{`Then you create a hook and paste it in React Bricks settings.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/07dc942626574fdab77e5627db8644cc/c655d/Vercel-deploy-hookfg5dgb.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "46.63677130044843%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'186\\'%20viewBox=\\'0%200%20400%20186\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M304%2076v6l1%205h28V76l-14-1-15%201m35%200v6l1%205h35V76l-18-1-18%201m-65%2043v11l1%209h98c2-1%202-2%202-10l-1-10c-2-2-99-2-100%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/07dc942626574fdab77e5627db8644cc/ca0a1/Vercel-deploy-hookfg5dgb.webp 223w", "/static/07dc942626574fdab77e5627db8644cc/75680/Vercel-deploy-hookfg5dgb.webp 445w", "/static/07dc942626574fdab77e5627db8644cc/8d1ba/Vercel-deploy-hookfg5dgb.webp 890w", "/static/07dc942626574fdab77e5627db8644cc/3838e/Vercel-deploy-hookfg5dgb.webp 1335w", "/static/07dc942626574fdab77e5627db8644cc/65131/Vercel-deploy-hookfg5dgb.webp 1586w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/07dc942626574fdab77e5627db8644cc/e92b6/Vercel-deploy-hookfg5dgb.png 223w", "/static/07dc942626574fdab77e5627db8644cc/e66bf/Vercel-deploy-hookfg5dgb.png 445w", "/static/07dc942626574fdab77e5627db8644cc/4ef49/Vercel-deploy-hookfg5dgb.png 890w", "/static/07dc942626574fdab77e5627db8644cc/4e814/Vercel-deploy-hookfg5dgb.png 1335w", "/static/07dc942626574fdab77e5627db8644cc/c655d/Vercel-deploy-hookfg5dgb.png 1586w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/07dc942626574fdab77e5627db8644cc/4ef49/Vercel-deploy-hookfg5dgb.png",
                "alt": "Vercel deploy hook",
                "title": "Vercel deploy hook",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Vercel deploy hook`}</figcaption>{`
  `}</figure></p>
    <p>{`You'll need to set up your API key as a secret on Vercel. Automated deploys get an error otherwise, but not when you deploy manually. Not sure how that works 🤔`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/353ed201b2f1e4f311ec9d0683501a58/10ab7/React-Bricks-api-key-env-vars26g999.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "26.008968609865473%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'104\\'%20viewBox=\\'0%200%20400%20104\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M182%2067l-1%203c1%202%2014%203%2016%200h1c0%201%201%202%204%202s3%200%203-2c-1-3-3-4-3-1l-1-1c-1-2-1-2-4-1h-5l-2%201h-1l-3-1h-4m2%2011v4c2%201%203%200%202-2l1-1%201%203h29c1%201%202%200%202-3%200-2-5-3-7%200h-1c0-2-4-2-7-1h-3c-1%202-2%202-3%201h-3c0-1-1-2-6-2l-5%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/353ed201b2f1e4f311ec9d0683501a58/ca0a1/React-Bricks-api-key-env-vars26g999.webp 223w", "/static/353ed201b2f1e4f311ec9d0683501a58/75680/React-Bricks-api-key-env-vars26g999.webp 445w", "/static/353ed201b2f1e4f311ec9d0683501a58/8d1ba/React-Bricks-api-key-env-vars26g999.webp 890w", "/static/353ed201b2f1e4f311ec9d0683501a58/3838e/React-Bricks-api-key-env-vars26g999.webp 1335w", "/static/353ed201b2f1e4f311ec9d0683501a58/712a0/React-Bricks-api-key-env-vars26g999.webp 1552w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/353ed201b2f1e4f311ec9d0683501a58/e92b6/React-Bricks-api-key-env-vars26g999.png 223w", "/static/353ed201b2f1e4f311ec9d0683501a58/e66bf/React-Bricks-api-key-env-vars26g999.png 445w", "/static/353ed201b2f1e4f311ec9d0683501a58/4ef49/React-Bricks-api-key-env-vars26g999.png 890w", "/static/353ed201b2f1e4f311ec9d0683501a58/4e814/React-Bricks-api-key-env-vars26g999.png 1335w", "/static/353ed201b2f1e4f311ec9d0683501a58/10ab7/React-Bricks-api-key-env-vars26g999.png 1552w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/353ed201b2f1e4f311ec9d0683501a58/4ef49/React-Bricks-api-key-env-vars26g999.png",
                "alt": "React Bricks api key env vars",
                "title": "React Bricks api key env vars",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`React Bricks api key env vars`}</figcaption>{`
  `}</figure></p>
    <p>{`Anyone with edit access to your site can deploy changes. No dev environment required. Great when you're traveling and find a typo.`}</p>
    <h3 {...{
      "id": "the-mechanics-probably"
    }}>{`The mechanics, probably`}</h3>
    <p>{`React Bricks is closed source so this is a guess. I'll ask Matteo if I'm close :)`}</p>
    <p>{`The visual editor itself is made of unicorns and magic.`}</p>
    <p>{`Controls on the right are component props. Every change triggers a re-render because React.`}</p>
    <p>{`When you hit `}<inlineCode parentName="p">{`Save`}</inlineCode>{`, a JSON representation of each component's props and children saves to a database. A JSON for page structure describes the bricks order.`}</p>
    <p>{`Something like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    type: "page",
    name: "Home",
    bricks: [
        {
            type: "hero",
            props: [
                layout: "white",
                borderTop: "none",
                ...
            ],
            children: [
                ...
            ]
        }
    ]
}
`}</code></pre>
    <p>{`Then there's the `}<inlineCode parentName="p">{`[slug].tsx`}</inlineCode>{` component that represents each page. You can `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/cms_experiment/blob/master/pages/%5Bslug%5D.tsx"
      }}>{`see it here`}</a>{`.`}</p>
    <p>{`There's a `}<inlineCode parentName="p">{`getStaticProps`}</inlineCode>{` that phones home and fetches this JSON. The page then uses a `}<inlineCode parentName="p">{`<PageViewer>`}</inlineCode>{` component to render.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`export const getStaticProps: GetStaticProps = async (context) => {
  const { slug } = context.params
  const page = await fetchPage(slug.toString(), config.apiKey)
  return { props: { page } }
}

const Page: React.FC<PageProps> = ({ page }) => {
  // ..

  return (
    <Layout>
      // ...
      <PageViewer page={pageOk} />
    </Layout>
  )
}
`}</code></pre>
    <p>{`Neat trick.`}</p>
    <p>{`Works great because NextJS is smart enough to call this once. First visitor gets a slow page, everyone else gets blazing speed.`}</p>
    <h2 {...{
      "id": "but-why"
    }}>{`But Why?`}</h2>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media2.giphy.com/media/s239QJIh56sRW/giphy-loop.mp4?cid=7cf28b0f4262gbk2szzr0gfnhwn6060oaqlwra25ftpoalph&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`Adrian said it best on stream:`}</p>
    <blockquote>
      <p parentName="blockquote">{`I got tired of building 100 wordpress pages every year and hired a bunch of people. Became an agency and now I can focus on my unique value props.
This would make everything easier.`}</p>
    </blockquote>
    <p>{`He's right. Landing pages are the lettuce of webdev. Don't craft that shit by hand. You've got interesting things to do.`}</p>
    <p>{`Like creating custom bricks 😍`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Hi Swizec, `}<a parentName="p" {...{
          "href": "https://twitter.com/ReactBricks"
        }}>{`@ReactBricks`}</a>{` founder here. Thank you for your live! I'd like to point out that the power of React Bricks is creating your own content blocks as React components with a schema. The one used on this page are just the example ones that we put in the starter.`}</p>{`— Matteo Frana (@matfrana) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/matfrana/status/1359068598229225473"
      }}>{`February 9, 2021`}</a></blockquote>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: this is not an ad but the founders did ask me to check it out through a friend`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      